import React from 'react';
import {Table} from "react-bootstrap";
import {TouristServicesEditRoute} from "../../routesConstants";
import {Link} from "react-router-dom";
import numberFormat from "../../../helpers/numberFormat";

const DiffRustarTab = ({data}) => {
  return (
    <Table striped bordered hover>
      <thead>
      <tr>
        <td rowSpan={2}>Индивидуальный код</td>
        <td rowSpan={2}>Создано</td>
        <td rowSpan={2}>Период</td>
        <td className={'text-center'} colSpan={3}>
          Цена
        </td>
      </tr>
      <tr className={'text-center'}>
        <td>Kayar</td>
        <td>Rustar</td>
        <td>Разница</td>
      </tr>
      </thead>
      <tbody>
      {data.map((row, index)=> {
        return <tr key={index}>
          <td>
            {row.links.map((link, index) => {
              return <React.Fragment key={index}>
                <Link to={TouristServicesEditRoute + link.invoiceId} target={'_blank'}>
                  {link.orderId}
                </Link>
                <br/>
              </React.Fragment>
            })}
          </td>
          <td>{row.issueDate}</td>
          <td>{row.startDate} - {row.endDate}</td>
          <td className={'text-center'}>{numberFormat(row.price.kayar)}</td>
          <td className={'text-center'}>{numberFormat(row.price.rustar)}</td>
          <td className={'text-center'}>{numberFormat(Math.abs(row.price.kayar - row.price.rustar))}</td>
        </tr>
      })}

      </tbody>

    </Table>
  );
};

export default DiffRustarTab;
